module.exports = __webpack_public_path__ + "img/rolunk.27923a0c.webp";